import { createClient } from '@supabase/supabase-js';

// When VITE_PUBLIC_SUPABASE_URL is empty (e.g. the Docker/fnOS single-origin
// deployment), fall back to the page origin so the SPA always talks to the
// same host that served it - no per-host rebuild or IP configuration needed.
const url = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) || window.location.origin;
// The Worker authenticates with the user JWT. The public key is retained only
// for supabase-js protocol compatibility and is intentionally non-secret.
const anon = (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) || 'tapevault-cloudflare-public';

// Use a custom fetch with a generous timeout so large one-shot imports
// are not aborted prematurely.
const fetchWithTimeout: typeof fetch = (input, init) => {
  const timeoutMs = 60_000;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(input, { ...init, signal: controller.signal }).finally(() => clearTimeout(timer));
};

export const supabase = createClient(url, anon, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    flowType: 'pkce',
    detectSessionInUrl: false,
  },
  global: {
    fetch: fetchWithTimeout,
  },
});
